import discardConversationsOption from './actions/discardConversationsOption';
import { saveConversationsOptionFull } from './actions/saveConversationsOption';
import ConversationsFull from './components/ConversationsFull';
import ConversationsQuick from './components/ConversationsQuick';
import isConversationsOptionDirty from './utils/isConversationsOptionDirty';
import { Option, OptionQuickCustomRenderComponentProps, QuickSettingOrder } from 'owa-options-core';
import { OwaWorkload } from 'owa-workloads';
import * as React from 'react';

let ConversationsOption: Option = {
    key: 'conversations',
    titleStringKey: 'optionTitle_conversations',
    searchTermsStringKey: 'optionTitle_conversations',
    fullOptionFormSettings: {
        render: () => <ConversationsFull />,
        isDirty: isConversationsOptionDirty,
        onSave: saveConversationsOptionFull,
        onDiscard: discardConversationsOption,
    },
    quickOptionSettings: {
        rendering: {
            render: (props: OptionQuickCustomRenderComponentProps) => (
                <ConversationsQuick {...props} />
            ),
        },
        getOrder: () => QuickSettingOrder.Conversations,
        workloads: OwaWorkload.Mail,
        customTitle: 'options_conversations_quick_label',
        tooltip: {
            tooltipStringKey: 'options_conversations_quick_tooltip',
            shouldHideTooltip: () => false,
        },
    },
    allowedOptionKeys: ['Conversations'],
};

export default ConversationsOption;
